import { render } from "./ListLayout.vue?vue&type=template&id=6af87ada&scoped=true"
import script from "./ListLayout.vue?vue&type=script&lang=js"
export * from "./ListLayout.vue?vue&type=script&lang=js"

import "./ListLayout.vue?vue&type=style&index=0&id=6af87ada&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af87ada"]])

export default __exports__